/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getProfessionalQualificationActions, {
    getProfessionalQualificationTypes,
} from '../../../redux/editique/getProfessionalQualification'
import { Get } from '../../../serveur/axios'

function* getProfessionalQualificationSagas({ response }) {
    const {
        governorate,
        delegation,
        centreFormation,
        sector,
        year,
        from,
        to,
        fromSecondary,
        toSecondary,
    } = response

    let url = '/editique/professional_qualification?'

    if (governorate) {
        url = `${url}&gouvernorat=${governorate}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (centreFormation) {
        url = `${url}&centre_formation=${centreFormation}`
    }
    if (sector) {
        url = `${url}&secteur=${sector}`
    }
    if (year) {
        url = `${url}&annee=${year}`
    }
    if (from) {
        url = `${url}&from=${from}`
    }
    if (to) {
        url = `${url}&to=${to}`
    }
    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }
    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getProfessionalQualificationActions.getProfessionalQualificationSuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getProfessionalQualificationActions.getProfessionalQualificationFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getProfessionalQualificationActions.getProfessionalQualificationFailure(
                error
            )
        )
    }
}

export function* getProfessionalQualificationSaga() {
    yield takeLatest(
        getProfessionalQualificationTypes.GET_PROFESSIONAL_QUALIFICATION_REQUEST,
        getProfessionalQualificationSagas
    )
}
